import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import { AuthContext } from '../../context/AuthContext';
import { DespesasVendedorContext } from '../../context/DespesasVendedorContext';
import { DespesasVendedorType, ExpenseAttachmentView } from '../../context/hooks/useDespesasVendedor';

const DespesasVendedor = () => {
    const { objUserTk } = useContext(AuthContext);
    const {
        listDespesasVendedor,
        despesasVendedorPageCount,
        getAllDespesasVendedorPaged,
        aprovarDespesasVendedor,
        rejeitarDespesasVendedor,
        fetchExpenseAttachment,
        downloadExpenseAttachment,
    } = useContext(DespesasVendedorContext);

    const [currentPage, setCurrentPage] = useState(1);
    const [attachmentModalOpen, setAttachmentModalOpen] = useState(false);
    const [attachmentLoading, setAttachmentLoading] = useState(false);
    const [attachmentView, setAttachmentView] = useState<ExpenseAttachmentView | null>(null);
    const [attachmentDespesaId, setAttachmentDespesaId] = useState<number | null>(null);

    useEffect(() => {
        getAllDespesasVendedorPaged(1, 9, objUserTk.EmpresaId).catch(error => console.error("Erro ao buscar despesas:", error));
    }, [objUserTk.EmpresaId]);

    const onChangePaginationCommon = async (_e: any, value: any) => {
        setCurrentPage(value);
        await getAllDespesasVendedorPaged(value, 9, objUserTk.EmpresaId);
    };

    const getDespesasStatusLabel = (status: number) => {
        switch (status) {
            case 0: return "Pendente";
            case 1: return "Aprovada";
            case 2: return "Rejeitada";
            case 3: return "Cancelada";
            default: return "Desconhecido";
        }
    };

    const handleOpenAttachment = async (despesaId: number) => {
        try {
            setAttachmentLoading(true);
            const attachment = await fetchExpenseAttachment(despesaId);
            setAttachmentView(attachment);
            setAttachmentDespesaId(despesaId);
            setAttachmentModalOpen(true);
        } catch (error) {
            console.error("Erro ao abrir anexo:", error);
        } finally {
            setAttachmentLoading(false);
        }
    };

    const handleCloseAttachment = () => {
        if (attachmentView?.url) {
            window.URL.revokeObjectURL(attachmentView.url);
        }
        setAttachmentModalOpen(false);
        setAttachmentView(null);
        setAttachmentDespesaId(null);
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar brandText={"Despesas dos vendedores"} search={false} titleSearch={""} />

            <Container className="mt-5">
                <Row className="mt-4">
                    <Col>
                        <Table hover responsive className="table-striped custom-table">
                            <thead>
                                <tr>
                                    <th>Sequência</th>
                                    <th>Descrição</th>
                                    <th>Valores</th>
                                    <th>Data</th>
                                    <th>Status</th>
                                    <th>Categoria</th>
                                    <th>Vendedor</th>
                                    <th>Anexo</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listDespesasVendedor.map((despesasVendedor: DespesasVendedorType, index: number) => (
                                    <tr key={index}>
                                        <td>{despesasVendedor.id}</td>
                                        <td>{despesasVendedor.description}</td>
                                        <td>{(despesasVendedor?.value ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                        <td>{despesasVendedor.date ? new Intl.DateTimeFormat('pt-BR').format(new Date(despesasVendedor.date)) : ""}</td>
                                        <td>
                                            <span className={`badge ${despesasVendedor.status === 0 ? "bg-warning text-white" :
                                                despesasVendedor.status === 1 ? "bg-success text-white" :
                                                    despesasVendedor.status === 2 ? "bg-danger text-white" :
                                                        "bg-secondary text-white"
                                                }`}>
                                                {getDespesasStatusLabel(Number(despesasVendedor.status))}
                                            </span>
                                        </td>
                                        <td>{despesasVendedor.tipoDespesasVendedorName ?? "-"}</td>
                                        <td>{despesasVendedor.vendedorName ?? "-"}</td>
                                        <td>
                                            {despesasVendedor.hasExpensePhoto ? (
                                                <div className="d-flex gap-2">
                                                    <Button color="info" size="sm" title="Visualizar anexo" onClick={() => handleOpenAttachment(despesasVendedor.id)}>
                                                        <i className="fa-solid fa-eye me-1"></i> Ver
                                                    </Button>
                                                    <Button color="secondary" size="sm" title="Baixar anexo" onClick={() => downloadExpenseAttachment(despesasVendedor.id)}>
                                                        <i className="fa-solid fa-download me-1"></i> Baixar
                                                    </Button>
                                                </div>
                                            ) : (
                                                <span className="text-muted">Sem anexo</span>
                                            )}
                                        </td>
                                        <td>
                                            <Button
                                                color="success"
                                                size="sm"
                                                title="Aprovar"
                                                onClick={() => {
                                                    aprovarDespesasVendedor(despesasVendedor.id).then(success => {
                                                        if (success) {
                                                            getAllDespesasVendedorPaged(currentPage, 9, objUserTk.EmpresaId);
                                                        }
                                                    });
                                                }}
                                            >
                                                <i className="fa-solid fa-thumbs-up me-1"></i> Aprovar
                                            </Button>
                                            <Button
                                                color="danger"
                                                size="sm"
                                                title="Rejeitar"
                                                onClick={() => {
                                                    rejeitarDespesasVendedor(despesasVendedor.id).then(success => {
                                                        if (success) {
                                                            getAllDespesasVendedorPaged(currentPage, 9, objUserTk.EmpresaId);
                                                        }
                                                    });
                                                }}
                                            >
                                                <i className="fa-solid fa-thumbs-down me-1"></i> Rejeitar
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className="d-flex justify-content-end mt-3">
                            {despesasVendedorPageCount && (
                                <div className="d-flex justify-content-center mt-4">
                                    <PaginationMaterial onChange={(e: any, value: any) => onChangePaginationCommon(e, value)} count={despesasVendedorPageCount} />
                                </div>
                            )}
                            {listDespesasVendedor.length === 0 && <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>}
                        </div>
                    </Col>
                </Row>
            </Container>

            <Modal isOpen={attachmentModalOpen} toggle={handleCloseAttachment} centered size="lg">
                <ModalHeader toggle={handleCloseAttachment}>Visualização do anexo</ModalHeader>
                <ModalBody>
                    {attachmentLoading ? (
                        <div className="text-center py-5">Carregando anexo...</div>
                    ) : attachmentView ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 420 }}>
                            <div className="border rounded p-2 bg-white" style={{ maxWidth: "100%", maxHeight: 620 }}>
                                {attachmentView.contentType.includes("pdf") ? (
                                    <iframe src={attachmentView.url} title="Anexo despesa vendedor" style={{ width: "100%", height: "560px", border: "none" }} />
                                ) : (
                                    <img src={attachmentView.url} alt="Anexo despesa vendedor" style={{ maxWidth: "100%", maxHeight: "560px", objectFit: "contain", display: "block" }} />
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className="text-center py-5 text-muted">Nenhum anexo carregado.</div>
                    )}
                </ModalBody>
                <ModalFooter className="d-flex justify-content-between">
                    <Button color="secondary" onClick={handleCloseAttachment}>Cancelar</Button>
                    <Button color="primary" disabled={!attachmentView || attachmentDespesaId == null} onClick={() => attachmentDespesaId != null && downloadExpenseAttachment(attachmentDespesaId)}>
                        <i className="fa-solid fa-download me-1"></i> Baixar
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default DespesasVendedor;
